import React, { useEffect, useState } from "react";

import {
  Button,
  Form,
  FormField,
  Header,
  Input,
  Message,
  Segment,
} from "semantic-ui-react";
import { reset, resetPassword } from "../../redux/modules/auth";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { ErrorWrap } from "../../helpers/error";
import { routes } from "../../routes";
import { StyledLinks } from "./styled-components";
import { t } from "../../constant/translations";

type Props = {
  error?: Object,
  login?: Function,
  setField?: Function,
  resetPassword: Function,
  loading: boolean,
};

const PasswordResetComponent = ({
  error,
  login,
  setField,
  resetPassword,
  loading,
  reset,
}: Props) => {
  const [state, setState] = useState({ data: {} });

  useEffect(() => {
    reset();
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    resetPassword(state.data.email);
  };

  setField = (name, value) => {
    const data = state.data || {};
    if (value) {
      data[name] = value;
    } else {
      delete data[name];
    }
    setState({ data: data });
  };

  error = new ErrorWrap(error);
  return (
    <Form action="" onSubmit={onSubmit} error={error.exists()}>
      <Segment>
        <Header as={"h4"} dividing={false} textAlign={"center"}>
          {t("login.pass_manage")}
        </Header>
        <FormField>
          <Input
            name="email"
            icon="user"
            iconPosition="left"
            placeholder="Е-mail"
            error={error.exists()}
            onChange={(event) => setField("email", event.target.value)}
          />
        </FormField>
        <StyledLinks>
          <Link to={routes.authLogin}>{t("login.tologin")}</Link>
        </StyledLinks>

        <Message error content={error.getGlobal()} />
        <Button
          type="submit"
          fluid
          size="large"
          loading={loading}
          disabled={!state.data.email}
        >
          {t("labels.forwards")}
        </Button>
      </Segment>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    error: state.auth.error,
    userKey: state.auth.userKey,
    loading: state.auth.loggingIn,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const resetAndRedirect = (data) => {
    return (dispatch) => {
      dispatch(resetPassword(data)).then(() =>
        ownProps.history.push(routes.authPasswordResetSuccess)
      );
    };
  };

  return bindActionCreators(
    { resetPassword: resetAndRedirect, reset },
    dispatch
  );
};

export const PasswordReset = connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordResetComponent);
